<template>
    <div style="overflow-y: auto;">
          <b-overlay
          :show="show"
          spinner-variant="primary"
          spinner-large
          rounded="sm"
          style="height:100vh"
          variant="dark"
          id="loader"
        >
        <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderFixed/></b-col>
            <b-col cols="12 headerM"><HeaderMobile/></b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
                <b-breadcrumb style=" background-color: #e9ecef78;">
                    <b-breadcrumb-item href="#home">
                      <router-link to="/">
                          <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                          Home
                      </router-link>
                    </b-breadcrumb-item>
  
                   <b-breadcrumb-item href="#" active>Holding Details Update</b-breadcrumb-item>
                </b-breadcrumb>
              </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <span class="title">Holding Number/Assessment Id Update for GMC area</span>
            </b-col>
          </b-row>
          <hr/>
          <div style="padding-left:30px;  ">
                  
            <b-row style="padding-top: 10px;">
              <b-col col cols="4" sm="3" md="3" lg="2"  style="padding-top: 5px;">
              <b-form-input type="text"  value="" id="min" placeholder="min"  />
            </b-col>
              <b-col col cols="4" sm="3" md="3" lg="2"  style="padding-top: 5px;">
              <b-form-input type="text" value="" id="max" placeholder="max"  />
            </b-col>
                  <b-col col cols="4" sm="3" md="3" lg="2"  style="padding-top: 5px;">
                      <b-button @click="checkConsNo()" block pill variant="danger" size="md" class="go" style="width:100%">
                        Update Holding No
                      </b-button>
                  </b-col>
                  </b-row>
             <br>
          <br>
        <!-- </form> -->
  
        </div>
    </b-container>
    <br>
  
  
 
  
  
  </b-overlay>
    </div>
  
  </template>
  
  
  <script>
  import axios from 'axios';
  import HeaderFixed from '@/components/HeaderFixed.vue'
  import HeaderMobile from '@/components/HeaderMobile.vue'
  var CryptoJS = require("crypto-js");
  var consNo="";
  var consDetails = [];
  var holdingDetails = [];
  //const urlCommon = "http://localhost:8081/website";
  //const urlCommon = "https://www.apdcl.org/website";
  export default {
    name: 'ConsReg',
    components: {
  
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
      //MarqueeText
  
    },
    computed: {
  
    },
    data() {
      return {
          value: '',
          show: false,
          show1: false,
          show2 : false,
          consNumber: "",
          selected: null,
          assmntId :'',
          holdingNo:'',
          zone:'',
          houseNo:'',
          location:'',
          owner:'',
          fatherName:'',
          roadNo:'',
          roadName:'',
          ward:'',
          propertyType :'',
          consMobile :''
      }
    },
    methods: {
      reloadPage()
      {
        window.location.reload();
      },
  
      checkConsNo() {
        var min = document.getElementById("min").value;
        var max = document.getElementById("max").value;
       var parent = this;
        axios.get(this.$urlCommon+'/api/web/holding/getConsList?min='+min+'&max='+max)
          .then((response) => {
            
            var consList="Invalid Cons: ";
            var holdingList="Invalid Holding: ";
             response.data.consList.forEach((element) =>{
            
               axios.post(parent.$urlArms+'/RestAPI/myBijulee/ConsDetails?cons_no='+element[0])
                 .then((response2) => {
                  if(response2.data.message!="00")
                  {
                    consList=consList+"'"+element[0] +"',";
                    console.log(consList);
                  }
                  else{
                   // console.log("Consumer Valid");
                    
                      axios.post("https://gmcpropertytax.com/ptax/api/AssessmentController/get_assessment_record?AssessmentKey="+element[1])
                      .then(function(response1) {
                       // console.log(response1.data);
                        if(Object.keys(response1.data).length===0)
                          {
                            holdingList=holdingList+"'"+element[1] +"',";
                            console.log(holdingList);
                          }
                          else if(response1.data==="Assessment Info Error")
                          {
                            holdingList=holdingList+"'"+element[1] +"',";
                            console.log(holdingList);
                          }
                          else {
                          //  console.log("Holding Valid");
                            holdingDetails = response1.data;
                            consDetails=response2.data;
                           
                            var dataToSend = JSON.stringify({
                            "cons_no": consDetails.cons_no,
                            "cons_name": consDetails.cons_name,
                            "subdivision": consDetails.subDivisionName,
                            "category": consDetails.category_CODE+"-"+consDetails.category_NAME,
                            "connection_type": consDetails.connType,
                            "mobile": consDetails.mobile_no,
                            "property_type":  "NA",
  
                            "assessment_key": holdingDetails.AssessmentKey,
                            "holding_no":   holdingDetails.HoldingNo,
                            "zone": holdingDetails.Zone,
                            "house_no": holdingDetails.HouseNo,
                            "location": holdingDetails.LocationName,
                            "owner_name": holdingDetails.OwnerName,
                            "father_name": holdingDetails.FathersName,
                            "building_usage": holdingDetails.BuildingUsage,
                            "qtax_paid_upto": holdingDetails.QtaxPaidUpto,
                            "date_of_assesment": holdingDetails.DateOfAssessment,
                            "road_no": holdingDetails.RoadNo,
                            "road_name": holdingDetails.RoadName,
                            "ward": holdingDetails.Ward,
                            "uploaded_doc":"NA",
                            "area":"GMC",
                            "source":"GMC"
                          });
                         // console.log(dataToSend);
                        
  
                          var config = {
                  method: 'post',
                  url: "http://localhost:8081/website/api/web/LoadHoldingDetails",
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  data : dataToSend
                };
  
                axios(config)
                .then(function (response) {
                
                  if(response.data=="success")
                  {
                    console.log("update success")
                  }
                });
  
  
                          }
                    })
                  }
                  
                });
                
              });
              
            
          })
  
  
  
    },
  
  
  
  
  
  
  
  maxFiveHoldingCheck()
  {
    var holdingNo = this.holdingNo;
    var parent=this;
     parent.show= true;
    axios.get(this.$urlCommon+'/api/web/checkHoldingNoMaxFive?holdingNo='+holdingNo)
     .then((response) => {
     parent.show= false;
     console.log(response.data);
     if(response.data.status == "success")
     {
       if( parseInt(response.data.counter) < 5)
         {
           parent.sendOtp();
         }
       else {
           parent.$bvModal.show('failureModal2');
           document.getElementById("failMsg2").innerHTML="Holding Number / Assessment ID already linked with five APDCL connections";
         }
     }
     else {
         parent.$bvModal.show('failureModal');
         document.getElementById("failMsg").innerHTML="Holding Number Update Failed. Please Try Again.";
       }
  
   })
  },
  duplicateHoldingCheck()
  {
    var holdingNo = this.holdingNo;
    var parent=this;
     parent.show= true;
    axios.post(this.$urlCommon+'/api/web/checkHoldingNo?holdingNo='+holdingNo)
     .then((response) => {
     parent.show= false;
     console.log(response.data);
     if(response.data.data == "NotFound")
     {
       parent.sendOtp();
     }
     else {
       parent.$bvModal.show('failureModal');
       document.getElementById("failMsg").innerHTML="Holding Number Already Registered";
  
     }
  
   })
  },
  holdingUpdate(){
  
        var otp = document.getElementById("otp").value;
        var mobile = consDetails.mobile_no;
        var parent =this;
        parent.show2= true;
  
  
              var parent2=parent;
  
              var dataToSend = JSON.stringify({
                "cons_no": consDetails.cons_no,
                "cons_name": consDetails.cons_name,
                "subdivision": consDetails.subDivisionName,
                "category": consDetails.category_CODE+"-"+consDetails.category_NAME,
                "connection_type": consDetails.connType,
                "mobile": consDetails.mobile_no,
                "property_type":  parent2.propertyType,
  
                "assessment_key": parent.assmntId,
                "holding_no":   parent.holdingNo,
                "zone": holdingDetails.Zone,
                "house_no": holdingDetails.HouseNo,
                "location": holdingDetails.LocationName,
                "owner_name": holdingDetails.OwnerName,
                "father_name": holdingDetails.FathersName,
                "building_usage": holdingDetails.BuildingUsage,
                "qtax_paid_upto": holdingDetails.QtaxPaidUpto,
                "date_of_assesment": holdingDetails.DateOfAssessment,
                "road_no": holdingDetails.RoadNo,
                "road_name": holdingDetails.RoadName,
                "ward": holdingDetails.Ward,
                "uploaded_doc":"NA",
                "area":"GMC",
                "source":"GMC"
              });
  
                var parent3=parent2;
  
                var config = {
                  method: 'post',
                  url: parent2.$urlCommon+"/api/web/UpdateHoldingDetailsOTP?mobNo="+mobile+"&otp="+otp,
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  data : dataToSend
                };
  
                axios(config)
                .then(function (response) {
                  parent3.show2= false;
                console.log(response.data);
                  if(response.data.status=="success")
                  {
                    parent3.$bvModal.show('successModal');
  
                    // var data2push = response.data.dataToPush;
                    // var dataToPush = JSON.stringify({
                    //    "SUB_DIV":data2push.sub_DIV,
                    //    "CONS_NO":data2push.cons_NO,
                    //    "CONS_NAME":data2push.cons_NAME,
                    //    "CONS_ADDRESS":data2push.cons_ADDRESS,
                    //    "CONS_ADDRESS_2":data2push.cons_ADDRESS_2,
                    //    "CONS_PHONE_NO":data2push.cons_PHONE_NO,
                    //    "CATEGORY":data2push.category,
                    //    "LATITUDE":data2push.latitude,
                    //    "LONGITUDE":data2push.longitude,
                    //    "HOLDING_NO":data2push.holding_NO
                    //     })
                    //     console.log(dataToPush);
                    //     var config2 = {
                    //       method: 'post',
                    //       url: "https://gmcpropertytax.com/ptax/api/ApdclApiController/insertApdclData",
                    //       headers: {
                    //         'Content-Type': 'application/json'
                    //       },
                    //       data : dataToPush
                    //     };
                    //     axios(config2)
                    //     .then(function (response) {
                    //           console.log(response.data);
                    //     })
  
                  }
                  else if(response.data.status=="failure") {
                    parent3.$bvModal.show('failureModal');
  
                  }
                  else if(response.data.status=="exist") {
                    parent3.$bvModal.show('successModal2');
                    document.getElementById("successMsg").innerHTML=response.data.msg;
                  }
                  else {
                    parent.$bvModal.show('model');
                    document.getElementById("modalMsg").innerHTML="Invalid OTP";
                  }
                })
                .catch(function (error) {
                  console.log(error);
                    var parent=this;
                    parent3.$bvModal.show('failureModal');
                });
      },
  
    },
    mounted()
    {
      // axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
      //             document.getElementById("captcha").src= "data:image/png;base64,"+response.data;
  
      // })
    }
  }
  </script>
  
  <style scoped="true">
  .label{
  text-align:left
  }
  .data{
    font-weight: 500;
    color: #e64a19      ;
    font-size: 1.1rem;
  }
  .holdingData{
    font-weight: 500;
    color: black;
    font-size: 1rem;
  }
  .userDetails
  {
     visibility: hidden;
    opacity: 0;
    transition:visibility 0s, opacity 0.5s linear;
  }
  .showUserDetails
  {
   visibility: visible;
   opacity: 1;
  }
  hr {
     margin-top: 5px;
     margin-bottom: 5px;
    }
  .go:focus{
    box-shadow: none;
  }
  .modalFont{
    width: 100px;
    display: block;
    margin: 40px auto 0;
  }
  
  .path {
    stroke-dasharray: 1000;
    stroke-dashoffset: 0;
  }
  .path.circle {
    -webkit-animation: dash 0.9s ease-in-out;
    animation: dash 0.9s ease-in-out;
  }
  .path.line {
    stroke-dashoffset: 1000;
    -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
    animation: dash 0.9s 0.35s ease-in-out forwards;
  }
  .path.check {
    stroke-dashoffset: -100;
    -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
    animation: dash-check 0.9s 0.35s ease-in-out forwards;
  }
  
  p {
    text-align: center;
    margin: 20px 0 60px;
    font-size: 1.25em;
  }
  p.success {
    color: #73AF55;
  }
  p.error {
    color: #D06079;
  }
  .hideDiv
  {
    visibility: hidden;
    opacity: 0;
    transition:visibility 0s, opacity 0.5s linear;
  
      padding: 0rem;
  }
  .showDiv
  {
   visibility: visible;
   opacity: 1;
  }
  @-webkit-keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes dash {
    0% {
      stroke-dashoffset: 1000;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @-webkit-keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }
  @keyframes dash-check {
    0% {
      stroke-dashoffset: -100;
    }
    100% {
      stroke-dashoffset: 900;
    }
  }
  .headerF{
    display: block;
  }
  .headerM{
    display: none;
  }
  
  @media (max-width: 768px) {
      .headerF{
        display: none;
      }
      .headerM{
        display: block;
      }
    }
    @media (max-width: 768px) {
      .headerF{
        display: none;
      }
      .headerM{
        display: block;
      }
      .marginRight30px{
        margin-right: 30px !important;
      }
    }
    @media (max-width: 576px) {
      .marginTop10px{
        margin-top: 10px !important;
      }
    }
  
  </style>
  